import request from '@/utils/request';
import router from '@/router';

/* eslint-disable */
const actions = {
  async addBundle({ dispatch, commit }, bundle) {
    try {
      const { data } = await request.post('bundles', bundle);

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      router.push({ name: "marketing.bundles.edit", params: { uuid: data.bundle.uuid } });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
